import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NavController, PopoverController, ModalController, AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'src/app/service/app.service';
import { DataService } from 'src/app/service/data.service';
import { environment } from 'src/environments/environment';
import { SetPasswordPage } from '../set-password/set-password.page';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.page.html',
  styleUrls: ['./menu.page.scss'],
})
export class MenuPage implements OnInit {

  language: any;
  isCheckOut: boolean = false;
  version:string= environment.VERSION;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public navCtrl: NavController,
    public popoverCtrl: PopoverController,
    public modalController: ModalController,
    public alertController: AlertController,
    public translate: TranslateService,
    public appService: AppService) { }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.isCheckOut =  localStorage.getItem("checkout") == '1' ? true : false;
    this.language = localStorage.getItem("language") == '1' ? 1 : 2;
  }


  async logOut() {
    const alert = await this.alertController.create({
      header: localStorage.getItem("language") == '1' ? 'هل أنت واثق' : 'Are you sure',
      message: localStorage.getItem("language") == '1' ? 'هل ترغب بالخروج' : 'Do you want to logout',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
        }, {
          text: 'Yes',
          handler: () => {
            localStorage.removeItem('auth_key');
            this.popoverCtrl.dismiss();
            this.navCtrl.navigateRoot('login');
          }
        }
      ]
    });
    await alert.present();
  }


  /**
   * @method { set password modal will open }
   * @memberof MenuPage
   */
  async setPassword() {
    const modal = await this.modalController.create({
      component: SetPasswordPage,
      cssClass: 'my-custom-class'
    });
    return await modal.present();
  }



  /**
   * @method { will switch lanaguage }
   * @memberof MenuPage
   */
  async changeLanguage() {
    const alert = await this.alertController.create({
      header: localStorage.getItem("language") == '1' ? 'هل أنت واثق' : 'Are you sure',
      message: localStorage.getItem("language") == '1' ?   'هل تريد تغيير اللغة؟' : 'Do you want to swicth language',
      buttons: [
        {
          text: 'No',
          role: 'cancel',
        }, {
          text: 'Yes',
          handler: () => {
            if (this.language === 2) {
              this.translate.use("ar");
              this.document.documentElement.dir = "rtl";
              localStorage.setItem("language", "1");
            } else {
              this.translate.use("en");
              this.document.documentElement.dir = "ltr";
              localStorage.setItem("language", "2");
            }
            this.popoverCtrl.dismiss(true);
          }
        }
      ]
    });
    await alert.present();
  }


  /**
   * @method { will switch lanaguage }
   * @memberof MenuPage
   */
  generatePaymentLink() {
    this.popoverCtrl.dismiss();
    this.navCtrl.navigateForward('payment-link')
  }

  viewPaymentLink() {
    this.popoverCtrl.dismiss();
    this.navCtrl.navigateForward('view-payment-link')
  }

  faq(){
    window.open("https://thawani.om/faq/")
  }

  support(){
    window.open("https://thawani.om/")
  }

}
